import { combineReducers } from '@ngrx/store';
import * as fromPrices from './prices.reducer';
import * as fromdAdditionalServices from './additional-services.reducer';
import * as fromOffer from './offer.reducer';

export interface RetailReviewState {
  pricesState: fromPrices.PricesState;
  additionalServicesState: fromdAdditionalServices.AdditionalServicesState;
  offerState: fromOffer.OfferState;
}

export const reducers = combineReducers({
  pricesState: fromPrices.pricesReducer,
  additionalServicesState: fromdAdditionalServices.additionalServicesReducer,
  offerState: fromOffer.offerReducer,
});
